let handle = 'listings';
const LOAD_MAP_HANDLE = [
    '.page-template-template-home'
];
if (LOAD_MAP_HANDLE.some((query) => document.querySelector(query))) {
    handle = 'map';
}
export const lazyLoad = () => {
    window.removeEventListener('scroll', lazyLoad);
    const element = document.createElement('script');
    element.src = window.mainSiteData.styleUrl + '/assets/js/' + handle + '.js';
    element.async = true;
    document.body.appendChild(element);
};
window.addEventListener('DOMContentLoaded', () => {
    if (LOAD_MAP_HANDLE.some((query) => document.querySelector(query)) ||
        !window.IntersectionObserver) {
        window.addEventListener('scroll', lazyLoad);
    }
    else {
        lazyLoad();
    }
});
